export default {
  retrievedServices: (state, services) => {
    state.services = services;
  },
  retrievedServiceTypes: (state, serviceTypes) => {
    state.services = serviceTypes;
  },
  addService: (state, service) => {
    state.services.push(service);
  },
  updateService: (state, service) => {
    state.services = state.services.map(item => {
      if (item.id === service.id) {
        return Object.assign({}, item, service);
      }
      return item;
    });
  }
};
